export default __webpack_public_path__ + "src/assets/emblue_logo.png";